import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useFlowStore } from '../stores/flowStore';
import { useAuth } from '../contexts/AuthContext';
import LoginButton from './Auth/LoginButton';
import LogoutButton from './Auth/LogoutButton';
import { appConfig } from '../config/appConfig';

export function Navbar() {
  const [apiStatus, setApiStatus] = useState<'checking' | 'online' | 'offline'>('checking');
  const { createNewFlow, isLoading } = useFlowStore();
  const { currentUser } = useAuth();

  const handleCreateFlow = async () => {
    try {
      // Create blank flow only
      const newFlow = await createNewFlow('Untitled Flow');
      
      if (newFlow?.id) {
        window.location.href = `/builder/${newFlow.id}`;
      }
    } catch (error) {
      console.error('Failed to create flow:', error);
    }
  };

  useEffect(() => {
    const checkApiStatus = async () => {
      try {
        // Use configuration for health check URL
        const healthUrl = `${appConfig.api.baseUrl.replace('/api', '')}/health`;
        const response = await fetch(healthUrl);
        if (response.ok) {
          setApiStatus('online');
        } else {
          setApiStatus('offline');
        }
      } catch (error) {
        setApiStatus('offline');
      }
    };

    checkApiStatus();
    // Check every 5 minutes instead of 30 seconds
    const interval = setInterval(checkApiStatus, 300000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
    <nav className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="text-xl font-bold text-blue-600">
              Dynamic Flow
            </Link>
            <div className="flex space-x-6">
              <Link 
                to="/" 
                className="text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
              >
                Dashboard
              </Link>

              <Link 
                to="/settings" 
                className="text-gray-600 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
              >
                Settings
              </Link>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            {/* API Status Indicator */}
            <div className="flex items-center space-x-2">
              <div className={`w-2 h-2 rounded-full ${
                apiStatus === 'online' ? 'bg-green-400' : 
                apiStatus === 'offline' ? 'bg-red-400' : 
                'bg-yellow-400'
              }`}></div>
              <span className="text-xs text-gray-500">
                API {apiStatus === 'checking' ? 'checking...' : apiStatus}
              </span>
            </div>

            {currentUser ? (
              <>
                <button 
                  onClick={handleCreateFlow}
                  disabled={isLoading}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
                >
                  {isLoading ? 'Creating...' : 'Create Flow'}
                </button>
                <LogoutButton />
              </>
            ) : (
              <LoginButton />
            )}
          </div>
        </div>
      </div>
    </nav>
    </>
  );
}
